var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#e87b35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.167,
    d: "M12.25 4.375V3.5a1.167 1.167 0 0 0-1.167-1.167H2.917A1.167 1.167 0 0 0 1.75 3.5v8.167a1.167 1.167 0 0 0 1.167 1.166h2.041M9.333 1.167V3.5M4.667 1.167V3.5M1.75 5.833h2.917m5.541 4.375-.875-.7V8.167"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#e87b35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.167,
    d: "M9.333 12.833a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleIcon);
export default __webpack_public_path__ + "static/media/schedule_icon.6a53bfac.svg";
export { ForwardRef as ReactComponent };